var map = {
	"./icon-label-backinstock": 65104,
	"./icon-label-backinstock/": 65104,
	"./icon-label-backinstock/index": 65104,
	"./icon-label-backinstock/index.js": 65104,
	"./icon-label-exclusive": 90142,
	"./icon-label-exclusive/": 90142,
	"./icon-label-exclusive/index": 90142,
	"./icon-label-exclusive/index.js": 90142,
	"./icon-label-justin": 60069,
	"./icon-label-justin/": 60069,
	"./icon-label-justin/index": 60069,
	"./icon-label-justin/index.js": 60069,
	"./icon-label-lowstock": 57730,
	"./icon-label-lowstock/": 57730,
	"./icon-label-lowstock/index": 57730,
	"./icon-label-lowstock/index.js": 57730,
	"./icon-label-monogrammable": 75443,
	"./icon-label-monogrammable/": 75443,
	"./icon-label-monogrammable/index": 75443,
	"./icon-label-monogrammable/index.js": 75443,
	"./icon-label-mostwished": 32807,
	"./icon-label-mostwished/": 32807,
	"./icon-label-mostwished/index": 32807,
	"./icon-label-mostwished/index.js": 32807,
	"./icon-label-onsale": 76465,
	"./icon-label-onsale/": 76465,
	"./icon-label-onsale/index": 76465,
	"./icon-label-onsale/index.js": 76465,
	"./icon-label-popular": 70975,
	"./icon-label-popular/": 70975,
	"./icon-label-popular/index": 70975,
	"./icon-label-popular/index.js": 70975,
	"./icon-label-sellingfast": 73804,
	"./icon-label-sellingfast/": 73804,
	"./icon-label-sellingfast/index": 73804,
	"./icon-label-sellingfast/index.js": 73804
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	if(!__webpack_require__.m[id]) {
		var e = new Error("Module '" + req + "' ('" + id + "') is not available (weak dependency)");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
webpackContext.id = 97843;
module.exports = webpackContext;